<template>
  <span :class="'font-bold ' + statusColor">
    <b>
      {{ $t(`extensions-monitor.table.statuses.${rowData.status}`) }}
    </b>
  </span>
</template>

<script>
export default {
  name: 'extensionsStatus',
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusColor() {
      switch (this.rowData.status) {
        case 'online':
          return 'text-success'
        case 'offline':
          return 'text-danger'
        default:
          return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
